import { NavigateFunction } from 'react-router-dom';

let navigateFn: NavigateFunction | undefined;

export function setNavigate(fn: NavigateFunction) {
  navigateFn = fn;
}

export function navigateTo(path: string, options = {}) {
  if (navigateFn) {
    navigateFn(path, options);
  } else {
    console.error('Navigate function not initialized yet.');
  }
}
